export default __webpack_public_path__ + "static/media/roboto-v20-latin-900italic.c20d916c.woff";